import { gql } from '@apollo/client'

export const createOneCredit = gql`
    mutation CreateOneCredit($date: String!, $userId: String!, $amount: Float!) {
        createOneCredit(date: $date, userId: $userId, amount: $amount) {
            amount
            id
        }
    }
`

export const updateUser = gql`
    mutation UpdateUser($userId: String!, $email: String, $role: Role, $isPremium: Boolean) {
        updateUser(userId: $userId, email: $email, role: $role, isPremium: $isPremium) {
            id
        }
    }
`

export const Login = gql`
    mutation Login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            user {
                id
            }
            token
        }
    }
`
export const createExplore = gql`
mutation CreateExplore($exRegion: [String!], $region: [String!], $webmUrl: String, $gif: String, $url: String, $thumbnailUrl: String, $aspectRatio: AspectRatioEnum, $style: ArtStyle, $motionScore: MotionScoreEnum, $categoryId: String, $lowResolutionUrl: String, $prompt: String) {
  createExplore(exRegion: $exRegion, region: $region, webmUrl: $webmUrl, gif: $gif, url: $url, thumbnailUrl: $thumbnailUrl, aspectRatio: $aspectRatio, style: $style, motionScore: $motionScore, categoryId: $categoryId, lowResolutionUrl: $lowResolutionUrl, prompt: $prompt) {
    id
    url
    lowResolutionUrl
    prompt
    thumbnailUrl
    motionScore
    style
    createdAt
    updatedAt
    aspectRatio
    location
    region
    exRegion
    gif
    webmUrl
    categoryId
  }
}
`
export const updateExplore = gql`
mutation UpdateExplore($exRegion: [String!], $region: [String!], $webmUrl: String, $gif: String, $url: String, $thumbnailUrl: String, $aspectRatio: AspectRatioEnum, $style: ArtStyle, $motionScore: MotionScoreEnum, $lowResolutionUrl: String, $prompt: String, $categoryId: String, $exploreId: String) {
  updateExplore(exRegion: $exRegion, region: $region, webmUrl: $webmUrl, gif: $gif, url: $url, thumbnailUrl: $thumbnailUrl, aspectRatio: $aspectRatio, style: $style, motionScore: $motionScore, lowResolutionUrl: $lowResolutionUrl, prompt: $prompt, categoryId: $categoryId, exploreId: $exploreId) {
    id
    url
    lowResolutionUrl
    prompt
    thumbnailUrl
    motionScore
    style
    createdAt
    updatedAt
    aspectRatio
    location
    region
    exRegion
    gif
    webmUrl
    categoryId
  }
}
`
export const deleteExplore = gql`
    mutation DeleteExplore($exploreId: String!) {
        deleteExplore(exploreId: $exploreId)
    }
`
export const createCategory = gql`
mutation CreateCategory($rowNumber: Int, $name: String) {
  createCategory(rowNumber: $rowNumber, name: $name) {
    id
    name
    rowNumber
    updatedAt
    createdAt
  }
}
`

export const updateCategory = gql`
mutation UpdateCategory($categoryId: String!, $name: String, $rowNumber: Int) {
  updateCategory(categoryId: $categoryId, name: $name, rowNumber: $rowNumber) {
    id
    name
    rowNumber
    createdAt
    updatedAt
  }
}
`

export const deleteCategory = gql`
    mutation DeleteCategory($categoryId: String!) {
        deleteCategory(categoryId: $categoryId)
    }
`
export const deleteVideo = gql`
    mutation DeleteVideoAdmin($videoId: String!) {
        deleteVideoAdmin(videoId: $videoId)
    }
`

export const updateSystem = gql`
    mutation UpdateSystem($systemType: SystemTypeEnum!, $provider: SystemProviderEnum!, $updateSystemId: String!) {
        updateSystem(systemType: $systemType, provider: $provider, id: $updateSystemId) {
            id
            provider
            type
            createdAt
            updatedAt
        }
    }
`
export const updateFeedStatus = gql`
    mutation UpdateFeedStatus($status: FeedStatus!, $feedId: String!) {
        updateFeedStatus(status: $status, feedId: $feedId) {
            id
        }
    }
`
export const sendFcm = gql`
    mutation SendFcm($message: String!, $title: String!, $fcmId: String!) {
        sendFcm(message: $message, title: $title, fcmId: $fcmId)
    }
`

export const userTransfer = gql`
    mutation UserTransfer($destinationId: String!, $sourceId: String!) {
        userTransfer(destinationId: $destinationId, sourceId: $sourceId)
    }

`

export const updateCredit = gql`
    mutation UpdateCredit($creditId: String!, $expiryDate: DateTime, $amount: Float) {
        updateCredit(creditId: $creditId, expiryDate: $expiryDate, amount: $amount) {
            id
        }
    }

`
export const updateVideoStatus = gql`
    mutation UpdateVideoStatus($status: StatusEnum!, $videoId: String!) {
        updateVideoStatus(status: $status, videoId: $videoId) {
            id
        }
    }
`



export const getSignedUrl = gql`
    mutation GetSignedUrl($fileName: String!) {
        getSignedUrl(fileName: $fileName) {
            id
            url
            contentType
        }
    }
`
export const getObjectUrl = gql`
    mutation GetObjectUrl($eTag: String!, $key: String!) {
        getObjectUrl(eTag: $eTag, key: $key)
    }
`



export const deleteUserData = gql`
    mutation DeleteUserData($userId: String!) {
    deleteUserData(userId: $userId) {
      success
      message
      deletedItems
    }
  }
`

export const updateMultipleFeedStatus = gql`
    mutation UpdateMultipleFeedStatus($status: FeedStatus!, $feedIds: [String!]!) {
        updateMultipleFeedStatus(status: $status, feedIds: $feedIds) {
            id
            status
        }
    }
`

export const createCreditProduct = gql`
  mutation CreateCreditProduct($input: CreateCreditProductInput!) {
    createCreditProduct(input: $input) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
    }
  }
`

export const updateCreditProduct = gql`
  mutation UpdateCreditProduct($input: UpdateCreditProductInput!, $updateCreditProductId: String!) {
    updateCreditProduct(input: $input, id: $updateCreditProductId) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
    }
  }
`

export const createTool = gql`
mutation CreateTool($input: CreateStudioInput!) {
  createTool(input: $input) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    rowNumber
    templateId
    prompt
    isFeatured
    duration
    categoryId
    cost
    provider
    createdAt
    updatedAt
    videoCount
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const updateTool = gql`
mutation UpdateTool($input: UpdateStudioInput!, $updateToolId: String!) {
  updateTool(input: $input, id: $updateToolId) {
    id
    name
    imageType
    bannerUrl
    videoUrl
    rowNumber
    templateId
    prompt
    isFeatured
    duration
    categoryId
    cost
    provider
    createdAt
    updatedAt
    videoCount
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const deleteTool = gql`
mutation DeleteTool($deleteToolId: String!) {
    deleteTool(id: $deleteToolId) {
      id
      name
      imageType
      bannerUrl
      videoUrl
      rowNumber
      templateId
      prompt
      isFeatured
      duration
      categoryId
      cost
      provider
      createdAt
      updatedAt
      videoCount
      webmUrl
      webpUrl
      aspectRatios {
        id
        width
        height
        name
        aspectRatioX
        aspectRatioY
        createdAt
        updatedAt
        toolId
      }
    }
  }
`